import React, { useState } from 'react'

import { Header } from '../../Typogaphy/Header';

import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Divider } from '@mui/material';
import Chip from '@mui/material/Chip';

import { FaUserCircle, FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import { pageRoutes } from '../../../routes/pageRoutes';

export const WorkExperience = ({ handleStepper }) => {

    const [workExp, setWorkExp] = useState(['test']);

    const handleAddWorkExp = () => {
        setWorkExp((prevItems) => [...prevItems, "Test" + workExp?.length]);
    }

    const removeItemByIndex = (indexToRemove) => {
        setWorkExp((prevItems) => {
            return prevItems.filter((_, index) => index !== indexToRemove);
        });

    };

    return (
        <div className='flex-1 overflow-y-auto p-4'>

            <div className='w-full items-center justify-between flex flex-row gap-2 my-3 max-sm:flex-col'>
                {/* <img
                    className='w-[200px] h-[50px]'
                    src={require('src/assets/logo2.png')}
                    alt=''
                /> */}

                <div className='items-center flex flex-col my-3'>
                    <Header text={"Work Experience"} style={"text-xl font-lexend"} />
                    <span className='text-green-600 font-light font-lexend text-sm'>Applicant's Information</span>
                </div>

            </div>


            <div className='w-full flex flex-col gap-3 mb-5'>

                <div className='w-full flex flex-end justify-end'>

                    <div onClick={() => handleAddWorkExp()} className='font-lexend bg-green-600 flex flex-row items-center gap-2 justify-center rounded py-2 px-3 cursor-pointer text-white text-xs hover:bg-green-800'>
                        <FaPlusCircle /><span>Add Work Experience</span>
                    </div>

                </div>


                {workExp?.map((item, key) => (
                    <React.Fragment>
                        <Divider><Chip label="Work Experience" color="success" variant="outlined" /></Divider>

                        <div className='w-full grid grid-cols-1 gap-2'>

                            <div className='grid grid-cols-3 max-md:grid-cols-1 gap-2'>
                                <FormControl fullWidth>
                                    <span className='mb-3 font-normal text-xs font-lexend'>Company</span>
                                    <TextField
                                        id="outlined-required"
                                        size="small"
                                        type='email'
                                        placeholder="type here..."
                                    />
                                </FormControl>

                                <FormControl fullWidth>
                                    <span className='mb-3 font-normal text-xs font-lexend'>Company Address</span>
                                    <TextField
                                        id="outlined-required"
                                        size="small"
                                        type='email'
                                        placeholder="type here..."
                                    />
                                </FormControl>

                                <FormControl fullWidth>
                                    <span className='mb-3 font-normal text-xs  font-lexend'>Contact Number</span>
                                    <TextField
                                        id="outlined-required"
                                        size="small"
                                        type='email'
                                        placeholder="type here..."
                                    />
                                </FormControl>
                            </div>
                            <div className='grid grid-cols-2 max-md:grid-cols-1 gap-2'>
                                <FormControl fullWidth>
                                    <span className='mb-3 font-normal text-xs  font-lexend'>Start Date</span>
                                    <TextField
                                        id="outlined-required"
                                        size="small"
                                        type='email'
                                        placeholder="type here..."
                                    />
                                </FormControl>

                                <FormControl fullWidth>
                                    <span className='mb-3 font-normal text-xs  font-lexend'>End Date</span>
                                    <TextField
                                        id="outlined-required"
                                        size="small"
                                        type='email'
                                        placeholder="type here..."
                                    />
                                </FormControl>
                            </div>

                            <FormControl fullWidth>
                                <span className='mb-3 font-normal text-xs font-lexend'>Position held</span>
                                <TextField
                                    id="outlined-required"
                                    size="small"
                                    type='email'
                                    placeholder="type here..."
                                />
                            </FormControl>

                            <FormControl fullWidth>
                                <span className='mb-3 font-normal text-xs font-lexend'>Job Description</span>
                                <TextField
                                    id="outlined-required"
                                    size="small"
                                    type='email'
                                    placeholder="type here..."
                                    multiline
                                    rows={5}
                                />
                            </FormControl>

                        </div>

                        {workExp?.length >= 2 &&
                            <div className='w-full flex flex-start justify-start'>
                                <div onClick={() => removeItemByIndex(key)} className='font-lexend bg-red-600 flex flex-row items-center gap-2 justify-center rounded py-2 px-3 cursor-pointer text-white text-xs hover:bg-red-800'>
                                    <FaMinusCircle /><span>Remove Work Experience</span>
                                </div>
                            </div>
                        }

                    </React.Fragment>
                ))}


                <div className='w-full flex flex-end justify-end'>

                    <div onClick={() => handleStepper(3)} className='font-lexend bg-green-600 flex flex-col items-center justify-center rounded py-2 px-3 cursor-pointer text-white font-medium hover:bg-green-800'>
                        <span>Save Work Experience</span>
                    </div>

                </div>

            </div>

        </div>
    )
}
